/* @flow */

import * as React from 'react'
import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'
import { Glyphicon } from 'react-bootstrap'
import { FiX, FiChevronLeft, FiChevronRight } from 'react-icons/fi'

import CloudinaryResource from '../../../../infrastructure/components/CloudinaryResource'
import MobileNavigation from '../../../../infrastructure/components/Mobile/MobileNavigation'
import type { ConnectedBrand } from '../../../types'
import {
  NAVIGATION_LINK_TYPE_SEARCH,
  NAVIGATION_LINK_TYPE_PAGE,
  NAVIGATION_LINK_TYPE_PAGE_V2,
  NAVIGATION_LINK_TYPE_BESTSELLERS,
  NAVIGATION_LINK_TYPE_FILE_BANK,
} from '../../shared'

type Props = {
  brand: ConnectedBrand,
  navigationFontColor: string,
  navigationLinks: Array<Object>,
  onHide: () => void,
  onShow: () => void,
  shopUrl: string,
  show: boolean,
}

const WebshopMobileNavigation = ({
  brand,
  navigationFontColor,
  navigationLinks,
  onHide,
  onShow,
  shopUrl,
  show,
}: Props) => {
  return (
    <MobileNavigationContainer>
      <MobileNavigationActivatorButton
        type="button"
        onClick={onShow}
        navigationFontColor={navigationFontColor}
      >
        <i className="fa fa-bars" />
      </MobileNavigationActivatorButton>
      <NavigationContainer>
        <MobileNavigation
          header={
            <>
              {brand.logo !== null && (
                <CloudinaryResource
                  brandId={brand.id}
                  id={brand.logo}
                  presets="logo_webshop_mobile_navigation"
                  transformationOverrides={logoTransformations}
                />
              )}

              <div className="close" onClick={onHide}>
                <FiX size={16} style={{ verticalAlign: 'middle' }} />
              </div>
            </>
          }
          onHide={onHide}
          show={show}
          wrapperClass="normal-scroll"
        >
          <MobileNavigation.ItemList>
            <li key={0}>
              <NavLink to={shopUrl} activeClassName="active" onClick={onHide}>
                <span>Home</span>
                <FiChevronRight size={12} style={{ verticalAlign: 'middle' }} />
              </NavLink>
            </li>

            {navigationLinks.map(link => {
              let href = shopUrl
              if (
                link.type === NAVIGATION_LINK_TYPE_SEARCH ||
                link.type === NAVIGATION_LINK_TYPE_BESTSELLERS
              ) {
                href = `${shopUrl}/search/${link.id}`
              } else if (
                link.type === NAVIGATION_LINK_TYPE_PAGE ||
                link.type === NAVIGATION_LINK_TYPE_PAGE_V2
              ) {
                href = `${shopUrl}/page/${link.settings.page_id}`
              } else if (link.type === 'linesheet') {
                href = `${shopUrl}/linesheet/${link.linesheet_public_id}`
              } else if (link.type === NAVIGATION_LINK_TYPE_FILE_BANK) {
                href = `/file-bank/${brand.id}`
              }

              return (
                <li key={link.id}>
                  <NavLink to={href} activeClassName="active" onClick={onHide}>
                    <span>{link.text}</span>
                    <FiChevronRight
                      size={12}
                      style={{ verticalAlign: 'middle' }}
                    />
                  </NavLink>
                </li>
              )
            })}

            <li>
              <NavLink to="/" activeClassName="active" onClick={onHide}>
                <span>Back to Traede</span>
                <FiChevronLeft size={12} style={{ verticalAlign: 'middle' }} />
              </NavLink>
            </li>
          </MobileNavigation.ItemList>
        </MobileNavigation>
      </NavigationContainer>
    </MobileNavigationContainer>
  )
}

export default WebshopMobileNavigation

const NavigationContainer = styled.nav.attrs({
  className: 'webshop-main-navigation-mobile',
})`
  ${MobileNavigation.ItemList} {
    text-transform: uppercase;
  }
`

const MobileNavigationContainer = styled.div``

const MobileNavigationActivatorButton = styled.button`
  display: block;
  background: transparent;
  border: 0;
  color: ${props => props.navigationFontColor || 'black'};
  outline: 0;
  font-size: 26px;
  padding: 10px;
  margin: -10px;

  & > i {
    display: block;
  }
`

const logoTransformations = {
  // so it works when a logo is transparent
  format: 'png',
}
